<template>
  <FlightDetailsBottomSheet
    :name="name"
    :dict="dict"
    :flights-list="params.flights"
    :city-mismatches="cityMismatches"
    :display-luggage="false"
    source-page="fareFamily"
  />
</template>

<script setup lang="ts">
  import type { Dict } from '@aviata/platform-types';
  import { FlightDetailsBottomSheet } from 'freedom-shared';
  import type { ticketDetails } from 'shared';

  import { useFareFlightDetailsBottomSheet } from './use-fare-flight-details-bottom-sheet';

  defineProps<{
    cityMismatches?: Array<ticketDetails.types.MismatchedCity> | null;
    dict?: Dict.Entity | null;
  }>();

  const { params, name } = useFareFlightDetailsBottomSheet();
</script>
